import { render, staticRenderFns } from "./R2.vue?vue&type=template&id=69b7c34f&scoped=true"
import script from "./R2.vue?vue&type=script&lang=js"
export * from "./R2.vue?vue&type=script&lang=js"
import style0 from "./R2.vue?vue&type=style&index=0&id=69b7c34f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7c34f",
  null
  
)

export default component.exports